import { cn } from '@/helpers/classnames';

interface CenteredColumnProps {
  children?: React.ReactNode;
  className?: string;
}

export const CenteredColumn = ({
  children,
  className,
}: CenteredColumnProps) => {
  return (
    <div
      className={cn(
        'mx-auto flex w-full max-w-panel-full flex-col gap-4 p-4 md:p-8',
        className,
      )}
    >
      {children}
    </div>
  );
};
